import { ReactElement, useEffect, useState } from 'react';
import MaterialTable, { Column } from 'material-table';
import { AcronymType } from '../../types/AcronymTypes';
import './Table.css';
import { TablePagination } from '@material-ui/core';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setAcronymsFilter, setFilteredAcronyms } from '../../redux/actions';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { UserInfoType } from '../../types/AppTypes';

interface TableProps {
  title: string | ReactElement;
  data: AcronymType[] | any[];
  columns: Column<AcronymType>[];
  loading: boolean;
  onRowClick: (row: any) => void;
  hasFiltering?: boolean;
}

const sizePerPageAcronymsChange = (sizePerPage: number) => {
  localStorage.setItem('acronyms-table-size', sizePerPage.toString());
};

const Table = ({ title, data, columns, loading, onRowClick, hasFiltering }: TableProps): JSX.Element => {
  const originalData = data;
  const [tableData, setTableData] = useState(originalData);
  const fData = useAppSelector((state) => state.acronyms);

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fData.acronyms.length === 0) {
      dispatch(setFilteredAcronyms(originalData));
      setTableData(originalData);
    } else {
      setTableData(fData.acronyms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (fData.length > 0) {
      setTableData(fData);
    }
  }, [fData]);

  const permissions = userInfo?.permissions;

  const doNothing=()=>{
  }

  return (
    <MaterialTable
      onRowClick={(e, row) => {(permissions?.includes('jargon.create') || permissions?.includes('jargon.edit') || permissions?.includes('jargon.delete') || userInfo?.isAdmin)  ? onRowClick(row) : e?.preventDefault()}}
      isLoading={loading}
      columns={columns}
      data={tableData}
      title={title}
      options={{
        actionsColumnIndex: -1,
        pageSize: parseInt(localStorage.getItem('acronyms-table-size') || '', 10) || 10,
        filtering: hasFiltering,
      }}
      components={{
        Pagination: (props: any) => <TablePagination {...props} />,
      }}
      onChangeRowsPerPage={(pageSize: number) => {
        sizePerPageAcronymsChange(pageSize);
      }}
      onFilterChange={(filters) => {
        const filterValue = filters[0].value[0];
        if (filterValue !== undefined) {
          const filtered = originalData.filter((dataRow) => dataRow.type?.toLowerCase() === filterValue);
          localStorage.setItem('acronym-filter', filterValue);
          setTableData(filtered);
          dispatch(setAcronymsFilter(filterValue));
          dispatch(setFilteredAcronyms(filtered));
        } else {
          localStorage.removeItem('acronym-filter');
          setTableData(originalData);
          dispatch(setFilteredAcronyms(originalData));
          dispatch(setAcronymsFilter(null));
        }
      }}
    />
  );
};

export default Table;
